import { Image, transformRESTImageToSDKImage } from '@wix/sdk-runtime/transformations/image';
import { VideoV2, transformRESTVideoV2ToSDKVideoV2 } from '@wix/sdk-runtime/transformations/video-v2';
import { Document, transformRESTDocumentToSDKDocument } from '@wix/sdk-runtime/transformations/document';
import { Audio, transformRESTAudioToSDKAudio } from '@wix/sdk-runtime/transformations/audio';
import { FileDescriptor } from '@wix/ambassador-media-site-media-v1-file-descriptor/types';
import { MediaType } from '../../constants/MediaType';
import { path } from 'ramda';

type MediaTransformer<T> = (data: T) => string;

const MEDIA_TYPE_CONFIG = {
  [MediaType.Picture]: {
    path: ['media', 'image', 'image'],
    transformer: transformRESTImageToSDKImage as MediaTransformer<Image>,
  },
  [MediaType.VectorArt]: {
    path: ['media', 'vector'],
    transformer: transformRESTImageToSDKImage as MediaTransformer<Image>,
  },
  [MediaType.Video]: {
    path: ['media', 'video'],
    transformer: transformRESTVideoV2ToSDKVideoV2 as MediaTransformer<VideoV2>,
  },
  [MediaType.Music]: {
    path: ['media', 'audio', 'assets', 0],
    transformer: transformRESTAudioToSDKAudio as MediaTransformer<Audio>,
  },
  [MediaType.Document]: {
    path: ['media', 'document'],
    transformer: transformRESTDocumentToSDKDocument as MediaTransformer<Document>,
  },
  [MediaType.Zip]: {
    path: ['media', 'archive'],
    transformer: null, // TODO: ignore
  },
} as const;

export const getCopyableWixUrl = async (item: FileDescriptor, mediaType: MediaType): Promise<string> => {
  const config = MEDIA_TYPE_CONFIG[mediaType];
  if (!config) {
    console.warn(`No configuration found for media type: ${mediaType}`);
    return '';
  }

  try {
    const itemData = path(config.path, item);
    if (!itemData) {
      console.warn(`No data found at path for media type: ${mediaType}`);
      return '';
    }

    if (!config.transformer) {
      console.warn(`No transformer available for media type: ${mediaType}`);
      return '';
    }

    return config.transformer(itemData);
  } catch (error) {
    console.error(`Failed to transform ${mediaType} data:`, error);
    return '';
  }
};
